import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { upPackagename, addPackagename, uPackagename } from "@/api/packagename";
export default {
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    var validate = function validate(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('pleaseInput')));
      } else if (/[A-Z\u4e00-\u9fa5]/.test(value)) {
        callback(new Error(_this.$t('cannotContainUppercaseChinese')));
      } else {
        callback();
      }
    };

    return {
      dialogFormVisible: false,
      titleNameKey: "",
      id: "",
      form: {
        pkg_name: "",
        status: "1",
        pkg_mark: ""
      },
      rules: {
        pkg_name: [{
          required: true,
          message: this.$t('pleaseInputPkgName'),
          trigger: "blur"
        }],
        pkg_mark: [{
          required: true,
          validator: validate,
          trigger: "blur"
        }]
      },
      formLabelWidth: "80px"
    };
  },
  created: function created() {},
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    // 打开修改新增
    init: function init(id, num) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$upPackagename, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (num == 1) {
                  _this2.titleNameKey = "addPkgName";
                  _this2.form = {
                    pkg_name: "",
                    status: "1",
                    pkg_mark: ""
                  };
                }

                _this2.id = id;

                if (!(id != "t")) {
                  _context.next = 14;
                  break;
                }

                if (!(num == 2)) {
                  _context.next = 14;
                  break;
                }

                _this2.titleNameKey = "modifyPkgName";
                tid = {
                  id: id
                };
                _context.next = 9;
                return upPackagename(tid);

              case 9:
                _yield$upPackagename = _context.sent;
                data = _yield$upPackagename.data;
                _this2.form.pkg_name = data.pkg_name;
                _this2.form.status = String(data.status);
                _this2.form.pkg_mark = data.pkg_mark;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 关闭弹窗或取消修改新增
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
      this.$refs.ruleForm.clearValidate();
    },
    // 确定添加修改
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (vali) {
        if (vali) {
          if (_this3.titleNameKey == "addPkgName") {
            _this3.form.id = null;
            addPackagename(_this3.form).then(function (res) {
              if (res.status == 200) {
                Message.success(res.message);

                _this3.$emit("refreshDataList");

                _this3.resetForm("ruleForm");
              }
            });
          }

          if (_this3.titleNameKey == "modifyPkgName") {
            _this3.form.id = _this3.id;
            uPackagename(_this3.form).then(function (res) {
              if (res.status == 200) {
                Message.success(res.message);

                _this3.$emit("refreshDataList");

                _this3.resetForm("ruleForm");
              }
            });
          }
        }
      });
    }
  }
};